//index.js

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// 예) src/index.js 최상단에만 넣기
import 'devextreme/dist/css/dx.material.blue.light.css';
import './App.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
